let config = null;

export const loadConfig = async () => {
  if (!config) {
    const response = await fetch(`/config.json?t=${Date.now()}`);
    config = await response.json();
  }
  return config;
};
